import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import {
  fetchBoxesApi,
  fetchUserByIdApi,
  fetchTaxonomyByIdApi,
  deleteBoxApi,
} from "../../Api/Box";
import toast from "react-hot-toast";
import Sidemodal from "../general/Sidemodal";
import { BoxForm } from "./BoxForm";
interface BoxProps {
  url: string;
}

export const Box = ({ url }: BoxProps) => {
  const [boxes, setBoxes] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchBoxesData = async () => {
    try {
      const data = await fetchBoxesApi(url);
      if (data && Array.isArray(data)) {
        const enrichedData = await Promise.all(
          data.map(async (box) => {
            const user = await fetchUserByIdApi(box.userId, url);
            const taxonomy = await fetchTaxonomyByIdApi(box.boxId, url);

            return {
              ...box,
              userName: user?.name || "Unknown User",
              taxonomyValue: taxonomy?.value || "Unknown Taxonomy",
            };
          })
        );
        setBoxes(enrichedData);
      }
    } catch (error) {
      console.error("Failed to fetch boxes data", error);
    }
  };

  useEffect(() => {
    fetchBoxesData();
  }, []);

  const handleDeleteClick = async (boxId: string) => {
    try {
      await deleteBoxApi(boxId, url);
      toast.success("Box deleted successfully");

      fetchBoxesData();
    } catch (error) {
      console.error("Error deleting Box:", error);
    }
  };

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBox, setEditBox] = useState<{ boxId?: string; userId?: string } | null>(null);

  const handleAddClick = () => {
    setEditBox(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (userId: string, boxId: string) => {
    setEditBox({ boxId, userId });
    setIsModalOpen(true);
  };

  const totalPages = Math.ceil(boxes.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentBoxes = boxes.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="px-2 md:px-4 mt-4">
      <div className='flex flex-row items-center '>
        <h1 className="text-3xl font-bold text-blue-600 mb-5 mt-5">Box</h1>
        <button
          type="button"
          className=" w-fit px-3 py-2 mx-3  tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
          onClick={handleAddClick}
        >
          <FaPlus className="w-3 h-3" />
        </button>
      </div>

      <div className="flex-grow ml-0 w-full mt-6">
        <input
          type="text"
          placeholder="Search Boxes"
          className="w-full mb-4 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="flex-grow ml-0 w-3/4">
        <form className="w-auto">{/* Search Form */}</form>
      </div>
      <div className="flex-grow ml-0 mt-4 w-full">
        <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg mt-6">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th
                  scope="col"
                  className="py-3.5 px-4 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  Actions
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-4 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <div className="flex items-center gap-x-3">
                    <span>Name</span>
                  </div>
                </th>

                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <button className="flex items-center gap-x-2">
                    <span>Box</span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
              {currentBoxes.length > 0 ? (
                currentBoxes.map((box) => (
                  <tr key={box.boxId}>
                    <td className="px-4 py-4 text-sm whitespace-nowrap">
                      <div className="flex items-center gap-x-6">
                        <button
                          onClick={() => handleDeleteClick(box.boxId)}
                          className="text-gray-500 transition-colors duration-200 dark:hover:text-red-600 dark:text-gray-300 hover:text-red-500 focus:outline-none"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => {
                            handleEditClick(box.userId, box.boxId);
                          }}
                          className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm font-medium text-gray-700">
                      {box.userName}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-500">
                      {box.taxonomyValue}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center py-4">
                    No boxes found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex items-center justify-between mt-6">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
              />
            </svg>
            <span>Previous</span>
          </button>

          <div className="items-center hidden lg:flex gap-x-3">
            {Array.from({ length: Math.min(10, totalPages) }, (_, index) => {
              const startPage = Math.max(1, currentPage - 5);
              const page = startPage + index;

              if (page > totalPages) return null;

              return (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-2 py-1 text-sm ${currentPage === page
                    ? "text-blue-500 bg-blue-100"
                    : "text-gray-500 hover:bg-gray-100"
                    } rounded-md`}
                >
                  {page}
                </button>
              );
            })}
          </div>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
          >
            <span>Next</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
              />
            </svg>
          </button>
        </div>
      </div>
      <Sidemodal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} >
        <BoxForm
          url={url}
          onClose={() => setIsModalOpen(false)}
          boxId={editBox?.boxId}
          userId={editBox?.userId}
        />
      </Sidemodal>

    </div>
  );
};
